import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
    Grid2x2 ,
    PenTool as Tool,
    ArrowRight,
    Home,
    Wrench,
    Paintbrush as Paint,
    Ruler,
    Image as ImageIcon,
    Plug,
    Droplet,
    ThermometerSunIcon, 
    Waves, 
    Hammer
} from "lucide-react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
} from "reactstrap";
      
import generalContractors from "./images/general-contractors.jpg";
import bathroomRemodel from "./images/bathroom-remodel.jpg";
import kitchenRemodel from "./images/kitchen-remodel.jpg";
import paintingService from "./images/painting.jpg";
import flooringService from "./images/flooring.jpg";
import electricalService from "./images/electrician.jpg";
import plumbingService from "./images/plumber.jpg";
import hvacService from "./images/hvac.jpg";
import windowInstallation from "./images/window-installation.jpg";
import roofing from "./images/roofing.jpg";
import swimmingPool from './images/swimming-pool.jpeg';
import handymanService from './images/handyman.jpg';

const PopularServices = () => {
  return (
    <React.Fragment>
      <section id="services" className="py-5 bg-white">
        <Container>
          <h2 className="fs-1 fw-bold text-center mb-5">
            Popular Home Services
          </h2>
          <Row>
            {[
              {
                icon: Home,
                title: "Home Building & Additions",
                desc: "New builds, room additions, or home expansions",
                image: generalContractors,
                slug: "general-contractors",
              },
              {
                icon: Wrench,
                title: "Kitchen Remodeling",
                desc: "Custom kitchen updates and layout changes",
                image: kitchenRemodel,
                slug: "kitchen-planning-remodeling-service",
              },
              {
                icon: Wrench,
                title: "Bathroom Remodeling",
                desc: "Bathroom upgrades including showers and tubs",
                image: bathroomRemodel,
                slug: "bathroom-remodeling",
              },
              {
                icon: Grid2x2,
                title: "Windows & Doors",
                desc: "Install or replace windows and doors",
                image: windowInstallation,
                slug: "windows-repair-replacement-installation",
              },
              {
                icon: Home,
                title: "Roofing",
                desc: "Roof repair or full replacement services",
                image: roofing,
                slug: "windows-repair-replacement-installation", // You may want to fix this slug
              },
              {
                icon: Plug,
                title: "Electrical",
                desc: "Wiring, lighting, and electrical services",
                image: electricalService,
                slug: "electricians",
              },
              {
                icon: Droplet,
                title: "Plumbing",
                desc: "Repairs, installations, and plumbing fixes",
                image: plumbingService,
                slug: "plumbers",
              },
              {
                icon: ThermometerSunIcon,
                title: "HVAC",
                desc: "Heating, cooling, and air system services",
                image: hvacService,
                slug: "air-conditioning-contractors-systems",
              },
              {
                icon: Ruler,
                title: "Flooring",
                desc: "Install or replace wood, tile, or carpet",
                image: flooringService,
                slug: "flooring-contractors",
              },
              {
                icon: Paint,
                title: "Painting",
                desc: "Interior and exterior painting services",
                image: paintingService,
                slug: "painting-contractors",
              },
              {
                icon: Waves,
                title: "Swimming Pools",
                desc: "Pool installation, repair, and remodeling",
                image: swimmingPool,
                slug: "swimming-pool-construction",
              },
              {
                icon: Hammer,
                title: "Handyman Services",
                desc: "General home repairs and maintenance",
                image: handymanService,
                slug: "handyman-services",
              }
            ].map((service, index) => (
              <Col md="3" className="mb-4" key={index}>
                <Card className="shadow-sm hover-shadow mb-0">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="card-img-responsive"
                  />
                  <CardBody className="p-4">
                    <div className="d-flex align-items-center mb-3 gap-2">
                      <service.icon size={18} />
                      <span className="fs-5 fw-semibold">{service.title}</span>
                    </div>
                    <p className="text-muted mb-3">{service.desc}</p>
                    <Link to={`/contractors/${service.slug}`}>
                      <div className="text-primary d-flex align-items-center cursor-pointer">
                        <span className="me-2">Find Pros</span>
                        <ArrowRight className="icon-sm" />
                      </div>
                    </Link>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      </React.Fragment>
    );
  };
  
  export default PopularServices;